<template>
  <div class="Blink_Setting">
    <table>
      <tr align="left">
        <td class="Blink_name" style="font-size: 26px; table-layout: fixed">
          {{ $t("langcfg.txtBlink") }}:
        </td>
        <td>
          <el-switch
            v-model="isDrawBlink"
            :active-text="showText"
            :inactive-text="notShowText"
            @change="changeSwitch"
          >
          </el-switch>
        </td>
      </tr>
    </table>
    <div>
      <el-form class="demo-form-inline">
        <el-form-item :label="`${$t('langcfg.txtShootingDuration')}:`">
          <el-select v-model="BlinkTime" @change="changeTime" placeholder="">
            <el-option label="20" value="20"></el-option>
            <el-option label="30" value="30"></el-option>
            <el-option label="60" value="60"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import EVENTS from "../../../bus";
import { saveCaptureSettings } from "../../../settings";
import { isDefined } from "../../../shared/utils";
export default {
  name: "BlinkSetting",
  data() {
    return {
      isDrawBlink: 1,
      showText: this.$t("langcfg.txtInfraredLamp"),
      notShowText: this.$t("langcfg.txtNaturalLight"),
      BlinkTime: 60
    };
  },
  mounted() {
    if (isDefined(window.captureSettings.isDrawBlink)) {
      this.isDrawBlink = window.captureSettings.isDrawBlink === 1;
    } else {
      this.isDrawBlink = true;
      window.captureSettings.isDrawBlink = 1;
      saveCaptureSettings(window.captureSettings);
    }
    if (isDefined(window.captureSettings.BlinkTime)) {
      this.BlinkTime = window.captureSettings.BlinkTime;
    } else {
      this.BlinkTime = 60;
      window.captureSettings.BlinkTime = 60;
      saveCaptureSettings(window.captureSettings);
    }
  },
  methods: {
    changeSwitch(val) {
      window.captureSettings.isDrawBlink = val ? 1 : 0;
      this.$bus.$emit("camInit");
      saveCaptureSettings(window.captureSettings);
      this.$bus.$emit("lampInit", "blink");
    },
    changeTime(val) {
      window.captureSettings.BlinkTime = Number(val);
      saveCaptureSettings(window.captureSettings);
      this.$bus.$emit("tip-switch");
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
.Blink_Setting {
  .demo-form-inline {
    margin-top: 30px;
  }

  margin-top: 30px;
  margin-left: 40px;
  /deep/ .el-form-item__label {
    font-size: 28px !important;
  }
  /deep/ .el-form-item {
    text-align: left;
  }
}
.Blink_name {
  padding-top: 10px;
}
/deep/.el-switch__label * {
  font-size: 27px;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/BlinkSetting.vue